import axios from "../helpers/axios";
import { galleryImgUserConstants } from "./constants";
import store from "../store";


let galleryItemsRequest = null;
let galleryEndpointUnavailable = false;

const readLocalGalleryItems = () => {
  try {
    const parsed = JSON.parse(localStorage.getItem('galleryItemData') || '[]');
    return Array.isArray(parsed) ? parsed.filter(Boolean) : [];
  } catch (_error) {
    return [];
  }
};

const dispatchLocalGalleryItems = (dispatch) => {
  const galleryImagesUser = readLocalGalleryItems();

  dispatch({
    type: galleryImgUserConstants.GET_GALLERY_IMAGES_SUCCESS,
    payload: { galleryImagesUser },
  });

  return galleryImagesUser;
};

const getGalleryImgUserItems = (sort = "all") => {
  return async (dispatch) => {
    const { auth: { authenticate } } = store.getState();

    if (!authenticate || galleryEndpointUnavailable) {
      return dispatchLocalGalleryItems(dispatch);
    }

    dispatch({ type: galleryImgUserConstants.GET_GALLERY_IMAGES_REQUEST });

    try {
      if (!galleryItemsRequest) {
        galleryItemsRequest = axios
          .get(`/galleryImgUser/get`, { params: { sort } })
          .finally(() => {
            galleryItemsRequest = null;
          });
      }

      const res = await galleryItemsRequest;

      if (res.status === 200) {
        dispatch({
          type: galleryImgUserConstants.GET_GALLERY_IMAGES_SUCCESS,
          payload: res.data,
        });

        return res.data;
      }

      return dispatchLocalGalleryItems(dispatch);
    } catch (error) {
      if (error?.response?.status === 404) {
        galleryEndpointUnavailable = true;
        return dispatchLocalGalleryItems(dispatch);
      }

      dispatch({
        type: galleryImgUserConstants.GET_GALLERY_IMAGES_FAILURE,
        payload: { error },
      });

      return null;
    }
  };
};


export const addToGalleryImgUser = (payload) => {
  return async (dispatch) => {
    const {
      galleryImgUser: { galleryImgUserItems },
      auth,
    } = store.getState();

    try {
      if (auth.authenticate) {
        dispatch({ type: galleryImgUserConstants.ADD_TO_GALLERY_IMG_REQUEST });

        const res = await axios.post("/galleryImgUser/add", {
          galleryItems: [payload],
        });

        if (res.status === 200) {
          dispatch(getGalleryImgUserItems("all"));
        }
      } else {
        const updatedGalleryImgUserItems = [...(Array.isArray(galleryImgUserItems) ? galleryImgUserItems : []), payload];
        localStorage.setItem("galleryItemData", JSON.stringify(updatedGalleryImgUserItems));

        dispatch({
          type: galleryImgUserConstants.ADD_TO_GALLERY_IMG_SUCCESS,
          payload: { galleryImgUserItems: updatedGalleryImgUserItems },
        });
      }
    } catch (e) {
      dispatch({
        type: galleryImgUserConstants.ADD_TO_GALLERY_IMG_FAILURE,
        payload: { galleryImgUserItems },
      });
    }
  };
};


export const removeGalleryImgUserItem = (payload) => {
  return async (dispatch) => {
    try {
      dispatch({ type: galleryImgUserConstants.REMOVE_ITEM_REQUEST });
      const res = await axios.post("/galleryImgUser/removeItem", payload);
      if (res.status === 200) {
        dispatch({
          type: galleryImgUserConstants.REMOVE_ITEM_SUCCESS,
          payload: res.data
        });
        dispatch(getGalleryImgUserItems());
      } else {
        dispatch({
          type: galleryImgUserConstants.REMOVE_ITEM_FAILURE,
          payload: res.data
        });
      }
    } catch (error) {
      console.log(error);
    }
  };
};

export const updateGalleryImgUserItem = () => {
  return async (dispatch) => {
    const { auth } = store.getState();
    const galleryImgUserItems = readLocalGalleryItems();

    if (auth.authenticate) {
      if (galleryImgUserItems.length > 0) {
        const payload = {
          galleryItems: galleryImgUserItems.map((item) => ({
            galleryItemId: item._id,
            img: item.img,
          })),
        };

        const res = await axios.post("/galleryImgUser/add", payload);

        if (res.status === 200) {
          localStorage.removeItem("galleryItemData");
          dispatch(getGalleryImgUserItems());
        }
      } else {
        dispatch(getGalleryImgUserItems());
      }
    } else {
      dispatch({
        type: galleryImgUserConstants.ADD_TO_GALLERY_IMG_SUCCESS,
        payload: { galleryImgUserItems },
      });
    }
  };
};


export { getGalleryImgUserItems };
